import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Carousel} from "react-responsive-carousel";
import HGTradingActivity from "../../components/Charts/MarketInsights/HGTradingActivity";
import HYTradingActivity from "../../components/Charts/MarketInsights/HYTradingActivity";
import AverageTradeSize from "../../components/Charts/MarketInsights/AverageTradeSize";
import HGTurnover from "../../components/Charts/MarketInsights/HGTurnover";
import TradedCUSIPS from "../../components/Charts/MarketInsights/TradedCUSIPS";
import CorporateDebtOutstanding from "../../components/Charts/MarketInsights/CorporateDebtOutstanding";
import PrimaryDealerNetPositions from "../../components/Charts/MarketInsights/PrimaryDealerNetPositions";

class MarketInsightsHighCharts extends Component {

    static propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        match: PropTypes.object.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        history: PropTypes.object.isRequired
    };

    shouldComponentUpdate(nextProps){
        const currentPath = this.props.history.location.pathname.replace(`/${this.props.match.params.id}`, '');
        const updatedPath = nextProps.history.location.pathname.replace(`/${nextProps.match.params.id}`, '');

        return currentPath !== updatedPath;
    }

    updateHistory = sliderNumber => {
        const {id} = this.props.match.params;
        if (sliderNumber === id) return;
        const url = this.props.match.path.replace(':id', sliderNumber);
        this.props.history.push(url);
    };

    render() {
        const {id} = this.props.match.params;

        return (
            <div>
                <h2 style={{textAlign: 'center'}}>Market Analysis</h2>
                <p>
                    Take advantage of market dynamics and investment trends with a variety of indicators updated daily,
                    weekly and quarterly.

                </p>
                <Carousel showArrows
                          showIndicators={false}
                          swipeable={false}
                          emulateTouch={false}
                          showThumbs={false}
                          showStatus={false}
                          onChange={this.updateHistory}
                          selectedItem={Number(id)}>
                    <HGTradingActivity/>
                    <HYTradingActivity/>
                    <AverageTradeSize/>
                    <HGTurnover/>
                    <TradedCUSIPS/>
                    <CorporateDebtOutstanding/>
                    <PrimaryDealerNetPositions/>
                </Carousel>
            </div>
        );
    }
}

export default MarketInsightsHighCharts;



// WEBPACK FOOTER //
// ./frontend/pages/Charts/MarketInsightsHighCharts.jsx